import { createSlice } from '@reduxjs/toolkit'
import { PaginationState } from '../types/pagination.type'
import { FIELD_VALUE_CONSTANTS } from '../utils/constants'

const tablePaginationInitialState: PaginationState = {
  numOfRows: { 'default': FIELD_VALUE_CONSTANTS.TWENTY_FIVE },
}

const tablePaginationSlice = createSlice({
  name: 'pagination',
  initialState: tablePaginationInitialState,
  reducers: {
    updateNumOfRows: (state, action) => {
      if (action?.payload?.numOfRows && action?.payload?.key) {
        state.numOfRows[action?.payload?.key] = action?.payload?.numOfRows
      }
    },
  },
})
export const { updateNumOfRows } = tablePaginationSlice.actions
export default tablePaginationSlice.reducer
